/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Offline_Activation_Code_PlaceholderInputs */

const en_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your activation code`)
};

const fr_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez votre code d'activation`)
};

const de_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie Ihren Aktivierungscode ein.`)
};

const it_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci il tuo codice di attivazione`)
};

const ru_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Введите свой код активации`)
};

const es_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduzca su código de activación`)
};

const zh_cn2_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入您的激活码`)
};

const ja_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アクティベーションコードを入力してください`)
};

const hi_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपना एक्टिवेशन कोड दर्ज करें`)
};

const pt_pt2_login_offline_activation_code_placeholder = /** @type {(inputs: Login_Offline_Activation_Code_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insira seu código de ativação`)
};

/**
* | output |
* | --- |
* | "Enter your activation code" |
*
* @param {Login_Offline_Activation_Code_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_offline_activation_code_placeholder = /** @type {((inputs?: Login_Offline_Activation_Code_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Offline_Activation_Code_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_offline_activation_code_placeholder(inputs)
	if (locale === "de") return de_login_offline_activation_code_placeholder(inputs)
	if (locale === "it") return it_login_offline_activation_code_placeholder(inputs)
	if (locale === "ru") return ru_login_offline_activation_code_placeholder(inputs)
	if (locale === "es") return es_login_offline_activation_code_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_login_offline_activation_code_placeholder(inputs)
	if (locale === "ja") return ja_login_offline_activation_code_placeholder(inputs)
	if (locale === "hi") return hi_login_offline_activation_code_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_login_offline_activation_code_placeholder(inputs)
	return en_login_offline_activation_code_placeholder(inputs)
});